const PATH_CHILD_ATTRIBUTES = "Child:Attributes";
define(["dojo/_base/array", "dojo/_base/declare", "csi/heading/Ref"], function (array, declare, Ref) {
	return declare(Ref, {
		canCopy: function (/*Context*/ ctxCopy, /*Heading*/ h) {
			return true;
		},

		canPaste: function (/*Context*/ ctxCopy, /*Context*/ ctxPaste, /*Heading*/ h) {
			// summary: must use the same size range and pasted base size must be in the sizes list
			var fromProduct = ctxCopy.getNode();
			var fromProductAttributes = ctxCopy.cache.getNode(fromProduct.Attributes);
			var toProduct = ctxPaste.getNode();
			var toProductAttributes = ctxPaste.cache.getNode(toProduct.Attributes);

			return (
				toProductAttributes.ActualSizeRange == fromProductAttributes.ActualSizeRange &&
				array.indexOf(toProduct.ProductSizes, fromProduct.DefaultSize) >= 0
			);
		},

		/**
         * Add any dependency paths required by renderer class
         * @param {Heading} h
         * @param {string[]} paths
         */
		addRendererDependencyPaths: function(h, paths) {
			paths.push(PATH_CHILD_ATTRIBUTES);
			this.inherited(arguments);
		 },
	});
});
